import { Guard, type GuardRun } from '../utils/Guard';
import { getPayAddress } from '$utils/getPayAddress';

export class RequirePayAddress extends Guard implements GuardRun {
  run() {
    if (!getPayAddress() && !this.target.includes('/card/status')) {
      return this.redirectTo('/gnosis-pay');
    }
  }
}
